import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, MenuItem,
Grid, Divider, Table, TableBody, TableCell,TableHead, TableRow, TablePagination, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { } from '@material-ui/icons';
import CircularProgress from '@material-ui/core/CircularProgress';
import {Line} from 'react-chartjs-2';
import Select from 'react-select';
import creds from '../../config/firebaseConfig';
import db from '../../config/firestoreConfig';

const styles = theme => ({
    placeholder: {
        display: 'block'
    },
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
        overflowX: 'auto'
       
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        overflowX: 'auto'
    },
    paper2: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        overflowX: 'auto'
    },
    button: {
        margin: theme.spacing.unit,
        width: 150 
      },
    table : {
        minWidth: 700
    },
    grid: {
        overflowX: 'auto',
        margin: 'auto'
    }
})

let id = 0;

class performance2_G extends Component {
    constructor(props){
        super(props)
        this.state = { 
            groups: [],
            page: 0,
            rowsPerPage: 5,
            loaded: false,
            rowRawData: [],
            selected: '',
            dialog: false,
            subject: ''
        }
    }

    async componentDidMount() {
        var groups = []
        
        const ref = await db.collection('WorkGroups').get()
        ref.forEach( group => { 
            groups.push(group.data())
        })
        this.setState({
            ...this.state,
            groups: groups,
            loaded: true
        })
    }

    handleChange = name => event => { 
        console.log(event.target.value)
        this.setState({
            ...this.state,
            [name]: event.target.value,
            PP: false
        })
        this.getContent(event.target.value)
    }

    getContent = async groupObj => { 
        console.log('SELECTED', groupObj)
        // console.log(groupObj) //debug
        var tasks = []; //Nested;
        var myTasks = []; //Nested
        var recentTasks = []; //Nested
        var top5 = []; //Nested
        var bot5 = []; //Nested
        var students = []; 
        var targets = [];
        var placeholder = [];
        var avgs = [];
        // var something = []; //debug

        groupObj.Members.forEach( async member => { 
            const index = groupObj.Members.indexOf(member)
            tasks.push([])
            myTasks.push([])
            recentTasks.push([])
            bot5.push([])
            top5.push([])
            avgs.push([])
            var relevant = []
            // something.push([])


            // console.log(index, tasks, myTasks, recentTasks, placeholder, index)

            const fetchStu = await db.collection('Users').where('UID', '==', member.uid).get()
            fetchStu.forEach( entry => { 
                console.log('FETCH', entry)
                students.push(entry.data())
                targets.push(entry.data().target)
            })

            const testRef = await db.collection('AssignedTasks').get()
            testRef.forEach( test => { 
                const members = test.data().AssignedTo
                members.forEach( stdnt => { 
                    if (stdnt.Student == member.uid){
                        var found = false;
                        tasks[index].forEach( obj => { 
                            if (obj.title == test.id){
                                return found = true;
                            }
                        })
                        if (!found){
                            tasks[index].push({title: test.id, data: test.data(), dueDate: test.data().Deadline})
                            myTasks[index].push({title: test.id, data: stdnt, dueDate: test.data().Deadline})
                        }
                        // console.log(test.id, stdnt, test.data().Deadline) //debug
                        // console.log(tasks[index], myTasks[index], something[index]) //debug
                    }
                })
            })

            // console.log(tasks[index], myTasks[index]) //debug
            tasks[index].sort(function (a,b){return new Date(a.data.Deadline).valueOf() - new Date(b.data.Deadline).valueOf()}) //just to be sure that it's ordered correctly
            myTasks[index].sort(function (a,b){return new Date(a.data.Deadline).valueOf() - new Date(b.data.Deadline).valueOf()}) //just to be sure that it's ordered correctly
            // console.log(tasks[index], myTasks[index]) //debug


            myTasks[index].forEach(task => { 
                if (recentTasks[index].length < 7){
                    if (task.data.CompletionDate != 'N/A') {
                        // recentTasks[index].push(task) //original way
                        //what if here we got the status straight away? 🤔
                        if (new Date(task.data.CompletionDate).valueOf() <= new Date(task.dueDate).valueOf()){
                            //push with status on time
                            task.status = 'On Time';
                            recentTasks[index].push(task)
                        } else {
                            //push with status late
                            task.status = 'Late';
                            recentTasks[index].push(task)
                        }
                    }
                }
            })

            console.log(recentTasks[index], tasks[index])
            var count = 0
            recentTasks[index].forEach(test => { 
                count ++;
                // console.log(test.title)
                tasks[index].forEach( cTest => {
                    if (cTest.title == test.title && relevant.indexOf(cTest) == -1){
                        relevant.push(cTest);
                         
                    }
                    return
                })
            })

            // console.log(myTasks[index], recentTasks[index], tasks[index], index, avgs[index])
            // const classAvgs =  await this.getClassAvg(relevant)
            var output = []
            await relevant.forEach( task => { 
                console.log('Tsk', task)
                var count = 0;
                var rT = 0;
                task.data.AssignedTo.forEach( student => { 
                    if (student.CompletionDate != 'N/A'){
                        count = count + 1;
                        rT = rT + student.Score
                    }
                })

                if (rT != 0){
                    output.push(rT/count)
                } else {
                    output.push(0)
                }
            })
            avgs[index].push(output)
            


            console.log('UPDATING STATE', tasks, myTasks, recentTasks, targets, avgs, students)
            this.setState({
                students: students,
                rTasks: recentTasks, 
                targets: targets, 
                avgs: avgs,
                PP: true
            })
 
        })
        
       
        
        
    }

    getClassAvg = async (relevant) => { 
        // console.log('RELE', relevant)
        var avgs = []
        await relevant.forEach( task => { 
            console.log('Tsk', task)
            var count = 0;
            var rT = 0;
            task.data.AssignedTo.forEach( student => { 
                if (student.CompletionDate != 'N/A'){
                    count = count + 1;
                    rT = rT + student.Score
                }
            })

            if (rT != 0){
                avgs.push(rT/count)
            } else {
                avgs.push(0)
            }
        })
        this.setState({
            ...this.state,
            loaded: true
        })
        
        
        return avgs

    }

    makeTableData = (sName, rTasks, avgs, studentObj, index) => { 
        console.log('TDATA', sName, rTasks, avgs, this.state.students, this.state.groups)
        return this.rows(sName, rTasks, avgs[0], studentObj, index) //Add back student obj with target
    }

    rows = (sName, rTasks, avgs, obj, index) => {
        console.log('ROWS', sName, rTasks, avgs)
        var output = []
        if (avgs) {
            rTasks.forEach( task => { 
                console.log('LINE 228', task.title, avgs)
                var tags = this.perQAnalysis(task)
                output.push(
                    this.createData(sName, task.title, task.dueDate, task.status, task.data.Score, tags.high, tags.low, avgs[rTasks.indexOf(task)]) //add back student obj with target
                )
            })
        }
        
        console.log('OUT', output)
        return output
    }

    createData = (sName, tName, dueDate, status, score, high, low, avg) => { 
        id += 1;
        console.log('CDATA', { id, sName, tName, dueDate, status, score, high, low, avg })
        return { id, sName, tName, dueDate, status, score, high, low, avg }
    }

    perQAnalysis = (testObj) => {
        // console.log('277', testObj) //debug
        var rawPerQ = testObj.data.perQuestion
        var outputH = []
        var outputL = []
        var placeholders = [] 
        

        rawPerQ.forEach( q => {
            var status = false; 
            if (q.result){
                status = true
            }
            q.tags.forEach( rawTag => { 
                var index = -1
                var duplicate = false;
                placeholders.forEach( tag => { 
                    if (tag.tag == rawTag ){
                        index = placeholders.indexOf(tag)
                        return duplicate = true;
                    }
                })
                if (!duplicate) {
                    // add the tag to placeholders
                    //gonna do status processing at the same time
                    if (status) {
                        placeholders.push({tag: rawTag, rT: parseInt(q.weight), totalMarks: parseInt(q.weight), percent: 100})
                    } else { 
                        placeholders.push({tag: rawTag, rT: 0, totalMarks: parseInt(q.weight), percent: 0})
                    }
                } else { 
                    //do status processing
                    console.log(index) //debug
                    if (status){
                        placeholders[index].rT = placeholders[index].rT + parseInt(q.weight)
                        placeholders[index].totalMarks = placeholders[index].totalMarks + parseInt(q.weight)
                        placeholders[index].percent = ((placeholders[index].rT / placeholders[index].totalMarks) * 100)
                    }
                }
            })
        })
        placeholders.sort(function (a,b){return a.percent - b.percent}) //just to be sure that it's ordered correctly
        if (placeholders.length > 3) { 
            outputL = [placeholders[0], placeholders[1], placeholders[2]]
            // console.log(placeholders, 'PHD') //debug
            placeholders.reverse()
            outputH = placeholders.splice(0, 3); 
        } else { 
            outputL = placeholders
            placeholders.reverse()
            outputH = placeholders
        }
        
        // console.log(outputL, outputH, ' PHDERS') //debug
        return {high: outputH, low: outputL}
    }

    handleChange2 = (name, title, rTasks) => { 
        console.log('HC2', name, title, rTasks)
        
        rTasks.forEach( task => {
            if (task.title == title) {
                console.log('BINGO')
                 this.setState({
                    ...this.state,
                    dialogData: task,
                    selectedStudent: task.data.displayName,
                    dialog: true 
                })
            } else {
                console.log('NOPE', task.title, title)
            }
        })

        // console.log('HC2', obj, displayName)
        // this.setState({
        //     ...this.state,
        //     dialogData: obj,
        //     selectedStudent: displayName,
        //     dialog: true 
        // })
    }

    handleClose = () => { 
        this.setState({
            ...this.state,
            dialog: false, 
            selectedStudent: '',
            dialogData: ''
        })
    }

    grabTarget = obj => { 
        const uid = obj.uid
        var out = 'N/A'
        db.collection('Users').where('UID', '==', uid).get()
        .then( snapshot => {
            snapshot.forEach( user => {
                return out = user.data().target
            })
        })
        return out
    }


    render(){
        const { classes } = this.props
        return (
            this.state.loaded && this.state.groups.length > 0 ?

            <div className={classes.root}>
                <Grid container
                    spacing={24}
                    direction='row'
                    jusitfy='space-evenly'
                    alignContent='center'
                >
                    <Grid item xs={4} className={classes.grid}>
                        <Paper className={classes.paper} elevation={1}>
                            <Typography variant='headline'>
                                Choose a group
                            </Typography>
                            <Divider/>
                            <br/>
                            <TextField
                                id='Group'
                                value={this.state.selected}
                                onChange={this.handleChange('selected')}
                                margin='normal'
                                helperText='Please select a group to view'
                                select
                            >
                                {this.state.groups.map(group => (
                                    <MenuItem key={this.state.groups.indexOf(group)} value={group}>
                                        {group.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Paper>
                    </Grid>

                    <Grid item xs={12}>

                    {this.state.selected != '' ?
                        
                        this.state.selected.Members.map( member => (  
                            <div>                      
                            <Paper className={classes.paper2}>
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow>
                                        <TableCell>User</TableCell>
                                        <TableCell>Task Name</TableCell>
                                        <TableCell>Date Due</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Score (%)</TableCell>
                                        <TableCell>Top 3 Areas</TableCell>
                                        <TableCell>3 Areas to improve</TableCell>
                                        <TableCell>Class Avg</TableCell>
                                        <TableCell>Target score</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {/* {console.log('INDEX', this.state.selected.Members.indexOf(member),  this.state.rTasks[this.state.selected.Members.indexOf(member)])} */}                                    
                                    <TableBody>
                                        {this.state.PP && this.state.rTasks.length > 0 && this.state.rTasks[this.state.selected.Members.indexOf(member)].length > 0 ? 
                                            this.makeTableData(member.Name, this.state.rTasks[this.state.selected.Members.indexOf(member)], this.state.avgs[this.state.selected.Members.indexOf(member)], this.state.students[this.state.selected.Members.indexOf(member)], this.state.selected.Members.indexOf(member))
                                                .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                                .map(row => { 
                                                    return (
                                                        <TableRow
                                                            key={row.id}
                                                            hover
                                                            tabIndex={-1}
                                                        >
                                                            <TableCell>{row.sName}</TableCell>
                                                            <TableCell>
                                                                <Button variant='outlined' className={classes.button} onClick={()=> {this.handleChange2('dialogData', row.tName, this.state.rTasks[this.state.selected.Members.indexOf(member)])}}>
                                                                    {row.tName}
                                                                </Button>
                                                            </TableCell>
                                                            <TableCell>{row.dueDate}</TableCell>
                                                            <TableCell>{row.status}</TableCell>
                                                            <TableCell>{row.score}</TableCell>
                                                            <TableCell>
                                                                {row.high.length  > 0 ?
                                                                    row.high.map(tag => (
                                                                        tag.tag + ', '
                                                                    ))
                                                                :
                                                                    '-'
                                                                
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {row.low.length  > 0 ?
                                                                    row.low.map(tag => (
                                                                        tag.tag + ', '
                                                                    ))
                                                                :
                                                                    '-'
                                                                
                                                                }
                                                            </TableCell>
                                                            <TableCell>{row.avg}</TableCell>
                                                            <TableCell>{this.grabTarget(this.state.selected.Members[this.state.selected.Members.indexOf(member)])}</TableCell>
                                                        </TableRow>
                                                    )
                                                })
                                        :
                                        
                                        
                                        <div style={ {margin: '50', width: '100%', height: '100%', alignContent: 'center' }}>
                                            <p>No Data</p>
                                        </div>
                                        }
                                        
                                    </TableBody>
                                </Table>
                            </Paper>
                            <br/>
                            <Divider/>
                            <br/>
                            </div>
                        ))
                    :
                                        <Paper className={classes.paper2}>
                                            <div style={ {margin: '50', width: '100%', height: '100%', alignContent: 'center' }}>
                                                <Typography variant='title'>
                                                    No Data
                                                </Typography>
                                            </div>
                                        </Paper>
                        
                    }
                    </Grid>
                </Grid>
                <Dialog
                        open={this.state.dialog}
                        onClose={this.handleClose}
                        aria-labelledby="form-dialog-title"
                    >
                    <DialogTitle id="form-dialog-title">{this.state.selectedStudent ? this.state.selectedStudent : <p/>} Recent Performance </DialogTitle>
                    <Divider/>
                    <DialogContent>
                    {this.state.dialog && this.state.dialogData ? 

                        <div>
                            <span style={{width: '100%'}} >
                                <br/>
                                
                                <Typography variant='subheading' >
                                    {'Task: ' + this.state.dialogData.title}
                                    <br/>
                                    {'Result: ' + this.state.dialogData.data.Score + '%'}
                                </Typography>
                            </span>
                            <br/>
                            <Divider/>
                            <Typography variant='body1'>
                                {'These questions need revising'}
                                <Divider/>
                            </Typography>
                            <br/>
                                {this.state.dialogData.data.perQuestion.map(question => { 
                                    if (!question.result) {
                                        return (
                                            <div>
                                                <Typography variant='subheading'>
                                                    {question.id + ': ' + question.question + ' ' }
                                                    {'- ' + question.weight + ' marks'}
                                                </Typography>
                                                {question.file ?
                                                    <Typography variant='body2'>
                                                        {'File: ' + question.file}
                                                    </Typography>
                                                :
                                                    <div/>
                                                }
                                                <Typography variant='caption'>
                                                    {'Areas: ' + question.tags.map(tag => { 
                                                        return tag + ' '
                                                    })}
                                                </Typography>
                                                <br/>
                                            </div>
                                        )
                                    } 
                                })
                            }
                        </div>
                
                    :
                        
                        <div/>
                    
                    }
                    
                    
                    </DialogContent>
                    <DialogActions>
                    <Button variant='raised' onClick={() => this.handleClose()}>
                            Close
                    </Button>
                    </DialogActions>
                </Dialog>
            </div>

            :

            <div style={{width: '100%'}}><CircularProgress/></div>

        )
    }
}

export default withStyles(styles)(performance2_G)


// WEBPACK FOOTER //
// ./src/pages/View/performance2_group.jsx